import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';

function formatDate(x) {
  const date = x.toLocaleDateString();
  const time = x.toLocaleTimeString();
  return `${date} ${time}`;
}
export default function EstimateTdUpdatedAt({updatedAt}) {
  const formatted = updatedAt ? formatDate(updatedAt) : null;

  return (
    <td>
      {formatted}
    </td>
  );
}

EstimateTdUpdatedAt.propTypes = {
  updatedAt: PropTypes.instanceOf(Date),
}
